<template>
  <div>
    <load v-if="loading" />
    <div v-else class="row">
      <div class="col-md-12">
        <h4 class="text-center">
          {{ $t("Histórico de Acolhimento") }}
        </h4>
        <print-content>
          <table class="table b-table table-bordered table-sm bg-white">
            <tbody>
              <tr>
                <td>
                  PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                </td>
                <td>
                  CADASTRADO:
                  <strong>{{ item.cadastrado }}</strong>
                </td>
                <td>
                  ATUALIZADO:
                  <strong>{{ item.atualizado }}</strong>
                </td>
                <td>
                  STATUS:
                  <b v-html="item.status_nome"></b>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  TÉCNICO:
                  <b v-if="item.user">{{ item.user.name }}</b>
                </td>
                <td colspan="2">
                  UNIDADE:
                  <b v-if="item.unidade">{{ item.unidade.nome }}</b>
                </td>
              </tr>

              <tr>
                <td colspan="3">
                  USUÁRIO:
                  <strong
                    class="mr-2"
                    v-for="(pessoa, index) in item.pessoas_objetos"
                    :key="pessoa.id"
                  >
                    {{ pessoa.nome_completo }} -
                    {{ pessoa.data_nascimento | calcIdade }}
                    ano(s)
                    <span v-if="index < item.pessoas_objetos.length - 1"
                      >,</span
                    >
                  </strong>
                </td>
                <td colspan="1" v-if="item.familia">
                  FAMÍLIA:
                  <b v-if="item.familia.codigo_familiar == ''">
                    ID: {{ item.familia.id }}
                  </b>
                  <b else>
                    CÓDIGO CADÚNICO:
                    {{ item.familia.codigo_familiar }}
                  </b>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  DATA INICIAL: <b>{{ item.data_inicial | formatDate }}</b>
                </td>
                <td colspan="2">
                  DATA FINAL: <b>{{ item.data_final | formatDate }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  UNIDADE ACOLHEDORA:
                  <b v-if="item.unidade_acolhedora">{{
                    item.unidade_acolhedora.nome
                  }}</b>
                  <b v-else>
                    {{ item.outra_unidade }}
                  </b>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  DETALHES DO ACOLHIMENTO:
                  <span v-html="item.detalhes"></span>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="text-center">
                  <br />
                  <hr />
                  <span class="flex justify-content-center" v-if="item.user">
                 
                    <print-footer v-if="item.user.tecnico.assinatura_digital" 
                      :tecnico="item.user.tecnico" 
                      class="mt-0" 
                      :assinatura="item.user.tecnico.assinatura_digital"
                      :email="email"
                      :wpp="wpp"
                    />
                    <b v-else>{{ item.user.name }}</b>
                    <br />
                    TÉCNICO DE REFERÊNCIA
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <p class="text-muted small" v-if="item.unidade">
            {{ app_cidade }}, {{ app_data_atual }} -
            {{ item.unidade.nome }}
          </p>

          <div class="row pt-4 px-0 d-flex justify-content-end no-print">
            <div class="col-auto px-2 text-right">
              <form-toggle
                grid="12"
                mt="0"
                v-model="email"
                label="Email"
              />
              <form-toggle
                grid="12"
                mt="0"
                v-model="wpp"
                label="Telefone/WhatsApp"
              />
              <router-link
                :to="`/dashboard/familia/acolhimentos/edit/${item.id}`"
                class="btn btn-default"
              >
                <i class="mdi mdi-arrow-left" />
              </router-link>

              <a class="btn btn-sm py-1 btn-primary" @click="print()">
                <i class="mdi mdi-printer mdi-18px" />
              </a>
            </div>
          </div>
        </print-content>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      servicos: [],
      unidades: [],
      email: true,
      wpp: true
    };
  },
  mounted() {
    this.getItem();
  },
  methods: {
    getItem() {
      axios
        .get(`api/dashboard/familia/acolhimentos/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
  },
};
</script>

<style>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
  }
  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
